import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../../modules/reports/general/openItemsReportActions'
import * as api from '../../../api/reports/general/openItems'

function* openItemsReportGetJobList(action) {
  try {
    const payload = yield call(api.getJobList, action.filters)
    yield put({ type: constants.OPEN_ITEMS_REPORT_GET_JOB_LIST.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.OPEN_ITEMS_REPORT_GET_JOB_LIST.FAILED,
      message: e.message || e
    })
  }
}

function* openItemsReportGetOrganizationList(action) {
  try {
    const payload = yield call(api.getOrganizationList)
    yield put({ type: constants.OPEN_ITEMS_REPORT_GET_ORGANIZATION_LIST.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.OPEN_ITEMS_REPORT_GET_ORGANIZATION_LIST.FAILED,
      message: e.message || e
    })
  }
}

function* openItemsReportGetFullReport(action) {
  try {
    const payload = yield call(api.getFullReport, action.filters)
    yield put({ type: constants.OPEN_ITEMS_REPORT_GET_FULL_REPORT.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.OPEN_ITEMS_REPORT_GET_FULL_REPORT.FAILED,
      message: e.message || e
    })
  }
}

/**
 * Saga
 */
function* watchOpenItemsReportGetJobList() {
  yield takeLatest(constants.OPEN_ITEMS_REPORT_GET_JOB_LIST.ACTION, openItemsReportGetJobList)
}

function* watchOpenItemsReportGetOrganizationList() {
  yield takeLatest(
    constants.OPEN_ITEMS_REPORT_GET_ORGANIZATION_LIST.ACTION,
    openItemsReportGetOrganizationList
  )
}

function* watchOpenItemsReportGetFullReport() {
  yield takeLatest(constants.OPEN_ITEMS_REPORT_GET_FULL_REPORT.ACTION, openItemsReportGetFullReport)
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchOpenItemsReportGetJobList),
    fork(watchOpenItemsReportGetOrganizationList),
    fork(watchOpenItemsReportGetFullReport)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/reports/general/openItemsReportSaga.js